import { Model } from './model';
export class ActionModel implements Model {
  name: string;
  _id: string;
  aId: number;
  objectTypes: string[];
  accepts: string[];
}
